<div ref:root>
  <LazyImage src="assets/images/model.svg" alt="model" aspectRatio={1072 / 178.3} border={false} background={false}/>
</div>

<script>
  export default {
    components: {
      LazyImage: "../library/LazyImage.html"
    }
  }
</script>

<style>
  ref:root {
    margin-bottom: 8px;
  }
</style>